import {
	Directive,
	Input,
	ElementRef,
	HostListener,
	Renderer2
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Directive({
	// tslint:disable-next-line:directive-selector
	selector: '[tooltip]'
})
export class TooltipDirective {
	// tslint:disable-next-line:no-input-rename
	@Input('tooltip') tooltipTitle: string;
	@Input() placement = 'top';
	@Input() delay;
	tooltip: HTMLElement;
	tooltipContent: HTMLElement;
	tooltipTriangle: HTMLElement;
	offset = 10;

	constructor(private el: ElementRef, private renderer: Renderer2) {
		/**
		 * Clean tooltip on contruct new tooltip
		 */
		const tooltips = document.querySelectorAll('.tooltip');
		if (tooltips.length) tooltips.forEach((cur, idx) => cur.remove());
	}

	@HostListener('focusin')
	@HostListener('mouseenter')
	onMouseEnter() {
		if (!this.tooltip && this.tooltipTitle !== null) {
			this.show();
		}
	}

	@HostListener('focusout')
	@HostListener('mouseleave')
	onMouseLeave() {
		if (this.tooltip && this.tooltipTitle !== null) {
			this.hide();
		}
	}

	@HostListener('click', ['$event.target'])
	onClick(btn) {
		window.setTimeout(() => {
			this.hide();
		}, 100);
	}

	show() {
		const tooltips = document.querySelectorAll('.tooltip');
		if (tooltips.length) tooltips.forEach((cur, idx) => cur.remove());

		this.create();
		this.setPosition();
		this.renderer.addClass(this.tooltip, 'tooltip-show');
	}

	hide() {
		if (this.tooltip) {

			this.renderer.removeClass(this.tooltip, 'tooltip-show');
			window.setTimeout(() => {
				if (document.body && this.tooltip) {
					this.renderer.removeChild(document.body, this.tooltip);
				}
				this.tooltip = null;
			}, this.delay);
		}
	}

	create() {
		this.tooltip = this.renderer.createElement('div');
		this.tooltipTriangle = this.renderer.createElement('div');
		this.tooltipContent = this.renderer.createElement('span');

		this.renderer.setProperty(this.tooltipContent, 'innerHTML', this.tooltipTitle);
		// this.renderer.appendChild(
		// 	this.tooltipContent,
		// 	this.renderer.createComment(this.tooltipTitle) // textNode
		// );

		this.renderer.appendChild(document.body, this.tooltip);
		// this.renderer.appendChild(this.el.nativeElement, this.tooltip);

		this.renderer.addClass(this.tooltipContent, 'tooltip__content');
		this.renderer.addClass(this.tooltipTriangle, 'tooltip__triangle');

		this.renderer.addClass(this.tooltip, 'tooltip');
		this.renderer.addClass(this.tooltip, `tooltip-${this.placement}`);

		this.renderer.appendChild(this.tooltip, this.tooltipContent);
		this.renderer.appendChild(this.tooltip, this.tooltipTriangle);

		this.tooltip.setAttribute('aria-live', 'polite');
		this.tooltip.setAttribute('role', 'tooltip');
	}

	setPosition() {
		const hostPos = this.el.nativeElement.getBoundingClientRect();
		const tooltipPos = this.tooltip.getBoundingClientRect();
		const tooltipTriangleWidth = 10;
		const safeOffset = 6;

		// window scroll top
		const scrollPos =
			window.pageYOffset ||
			document.documentElement.scrollTop ||
			document.body.scrollTop ||
			0;

		let top, left, leftTriangle;

		if (this.placement === 'top') {
			top = hostPos.top - tooltipPos.height - this.offset;
			left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
			leftTriangle =
				hostPos.left +
				(hostPos.width - tooltipTriangleWidth) / 2 -
				tooltipTriangleWidth / 2;
		}

		if (this.placement === 'bottom') {
			top = hostPos.bottom + this.offset;
			left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
			leftTriangle =
				hostPos.left +
				(hostPos.width - tooltipTriangleWidth) / 2 -
				tooltipTriangleWidth / 2;
		}

		if (this.placement === 'left') {
			top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
			left = hostPos.left - tooltipPos.width - this.offset;
			leftTriangle = hostPos.left - tooltipTriangleWidth - this.offset;
		}

		if (this.placement === 'right') {
			top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
			left = hostPos.right + this.offset;
			leftTriangle = hostPos.right + this.offset;
		}

		if (left < 0) {
			left = safeOffset;
			this.renderer.setStyle(this.tooltipTriangle, 'left', `${leftTriangle}px`);
		}

		if (document.documentElement.offsetWidth < left + tooltipPos.width) {
			this.renderer.setStyle(this.tooltip, 'margin-right', `${safeOffset}px`);
			this.renderer.setStyle(
				this.tooltipTriangle,
				'left',
				`calc(50% + ${(left +
					tooltipPos.width -
					document.documentElement.offsetWidth) /
				2 +
				safeOffset}px`
			);
		}

		this.renderer.setStyle(this.tooltip, 'left', `${left}px`);
		this.renderer.setStyle(this.tooltip, 'top', `${top + scrollPos}px`);
	}
}
